<template>
	<div id="slider-budget">
	  <vue-slider class="raleway-reg-p15" v-model="budget" v-bind="options" :tooltip-placement="['top', 'top-bottom']" />
	  <div class="d-flex justify-content-between mt-3">
		<div class="text-center">
		  <label class="raleway-reg-p13 d-block mb-2">Minimum</label>
		  <input
			  type="number"
			  class="budget-input mt-0"
			  v-model.number="budget[0]"
			  :min="options.min"
			  :max="budget[1]"
		  />
		</div>
  
		<div class="text-center">
		  <label class="raleway-reg-p13 d-block mb-2">Maximum</label>
		  <input
			  type="number"
			  class="budget-input mt-0"
			  v-model.number="budget[1]"
			  :min="budget[0]"
			  :max="options.max"
		  />
		</div>
	  </div>
	</div>
  </template>
  
  <script>
  import _ from 'lodash';
  
  export default {
	name: 'slider-budget',
	data() {
	  return {
		options: {
		  min: 50,
		  max: 5000,
		  dotSize: 20,
		  processStyle: {
			background: '#3B6152',
		  },
		  tooltip: 'always',
		  tooltipPlacement: 'top',
		  tooltipStyle: {
			background: 'transparent',
			border: 'transparent',
			color: '#3B6152',
			fontWeight: 'bold',
		  },
		  dotStyle: {
			backgroundColor: '#3B6152',
			border: 'none',
			width: '80%',
			height: '80%',
		  },
		  labelStyle: {
			color: '#3B6152',
			fontWeight: 'bold',
		  },
		},
		budget: [50, 5000],
	  };
	},
	methods: {
	  emitBudget: _.debounce(function (val) {
		this.$emit('changedBudget', val);
	  }, 500),
	},
	watch: {
	  budget(val) {
		this.emitBudget(val);
	  },
	},
  };
  </script>  

  <style scoped>
  .budget-input {
	width: 80px;
	text-align: center;
	padding: 5px;
	border: 1px solid #ccc;
	border-radius: 5px;
	margin-top: 5px;
  }
  </style>
  
